import * as pc from 'playcanvas'

export interface ScreenPos {
  x: number
  y: number
  visible: boolean
}

// Module-level scratch keeps the caller's world vector from aliasing output.
const screenOut = new pc.Vec3()

/** Project a world anchor to the overlay plane; null means behind the camera. */
export function computeLabelScreenPos(
  worldX: number,
  worldY: number,
  worldZ: number,
  worldToScreen: (pos: pc.Vec3, out: pc.Vec3) => pc.Vec3,
  tmpVec: pc.Vec3,
): ScreenPos | null {
  tmpVec.set(worldX, worldY, worldZ)
  worldToScreen(tmpVec, screenOut)
  if (screenOut.z <= 0) return null
  return { x: screenOut.x, y: screenOut.y, visible: true }
}
